module.exports = __webpack_public_path__ + "img/15 Animation 2-squashed.8af9aec5.jpg";